<template>
    <div>
        <div class="top-box">
            <img class="bg" src="@/assets/theme/light/share/14friendDesc/02bg.png">
            <div class="banner">
                <van-row>
                    <van-col span="6" @click="back"><img class="back-icon"
                                                         :src="require(`@/assets/theme/${theme}/status/01dailyActive/01back.svg`)">
                    </van-col>
                    <van-col span="12">
                    </van-col>
                    <van-col span="6" v-show="isFriend">
                        <img @click="getPrivilege" class="set-icon"
                             src="@/assets/theme/light/share/14friendDesc/01set.png">
                    </van-col>
                </van-row>
            </div>
            <img class="user-icon" :src="user.userAvatar ? user.userAvatar : defaultImg">
            <div class="user-name-remark">
                <div>{{ user.userNameRemark ? user.userNameRemark : user.userName }}</div>
            </div>
            <div class="user-info-btn">
                <div class="uuser-info-text" @click="toPersonal">个人资料</div>
            </div>
        </div>
        <div class="target-box">
            <div class="step-chart-box"></div>
            <span class="step-bar"></span>
            <div class="step-title">今日步数</div>
            <div class="step-target-value"><span class="step-current">{{ user.step }}</span><span
                class="target-num">/{{ user.userTargetStep }}<span
                class="unit">步</span></span></div>
            <span class="cal-bar"></span>
            <div class="cal-title">运动能耗</div>
            <div class="cal-target-value"><span class="cal-current">{{ user.calorie }}</span><span class="target-num">/{{
                    user.userTargetCalorie
                }}<span
                    class="unit">千卡</span></span></div>
            <div class="step-pro-box">
                <img class="step-icon" v-if="showTargetIcon" src="@/assets/theme/light/share/14friendDesc/11step.png">
                <img class="cal-icon" v-if="showTargetIcon" src="@/assets/theme/light/share/14friendDesc/11cal.png">
                <canvas id="myCanvas"></canvas>
                <canvas id="myCanvas2"></canvas>
            </div>
        </div>
        <div class="health-box" v-show="bodyStatus">
            <div class="privilege-title">运动能力</div>
            <div class="health-item-box">
                <van-row gutter="13">
                    <van-col span="12">
                        <div class="health-item">
                            <div class="health-item-title">最大摄氧量</div>
                            <div class="health-item-date">{{
                                    sportAbility.vo2max.date ?
                                        changeDate(sportAbility.vo2max.date) : '--'
                                }}
                            </div>
                            <canvas class="progress_bg" id="cpbg"></canvas>
                            <canvas class="progress_bar" id="cpbar"></canvas>
                            <canvas class="progress_line" id="cpline"></canvas>
                            <div class="vo2-value">{{ sportAbility.vo2max.value ? sportAbility.vo2max.value : '--' }}
                            </div>
                            <div class="vo2-level">{{ getVo2MaxLevel(sportAbility.vo2max.value) }}</div>
                        </div>
                    </van-col>
                    <van-col span="12">
                        <div class="health-item">
                            <div class="health-item-title">体能年龄</div>
                            <div class="health-item-date">{{
                                    sportAbility.fitnessAge.date ?
                                        changeDate(sportAbility.fitnessAge.date) : '--'
                                }}
                            </div>
                            <canvas class="circle-box" id="tnnl-chart"/>
                            <div class="vo2-value">{{
                                    sportAbility.fitnessAge.value ?
                                        sportAbility.fitnessAge.value : '--'
                                }}
                            </div>
                            <div class="vo2-level" v-if="sportAbility.fitnessAge.value">
                                体能年龄{{ character }}实际年龄
                            </div>
                            <div class="vo2-level" v-if="!sportAbility.fitnessAge.value">--</div>
                        </div>
                    </van-col>
                    <van-col span="12">
                        <div class="health-item">
                            <div class="health-item-title">短期负荷</div>
                            <div class="health-item-date">{{
                                    sportAbility.trainingLoad.date ?
                                        changeDate(sportAbility.trainingLoad.date) : '--'
                                }}
                            </div>
                            <canvas class="circle-box" id="fuhe-chart"/>
                            <div class="vo2-value">{{
                                    sportAbility.trainingLoad.value ?
                                        sportAbility.trainingLoad.value : '--'
                                }}
                            </div>
                            <div class="vo2-level">{{ getTrainingLoadLevel(sportAbility.trainingLoad.value) }}</div>
                        </div>
                    </van-col>
                    <van-col span="12">
                        <div class="health-item">
                            <div class="health-item-title">体能等级</div>
                            <div class="health-item-date">{{
                                    sportAbility.staminaLevel.date ?
                                        changeDate(sportAbility.staminaLevel.date) : '--'
                                }}
                            </div>
                            <canvas class="circle-box" id="tndj-chart"/>
                            <div class="vo2-value">{{
                                    sportAbility.staminaLevel.value ?
                                        sportAbility.staminaLevel.value : '--'
                                }}
                            </div>
                            <div class="vo2-level">{{ getStaminaLevel(sportAbility.staminaLevel.value) }}</div>
                        </div>
                    </van-col>
                    <van-col span="12">
                        <div class="health-item">
                            <div class="health-item-title">乳酸阈</div>
                            <div class="health-item-date">{{
                                    sportAbility.lactateHr.date ?
                                        changeDate(sportAbility.lactateHr.date) : '--'
                                }}
                            </div>
                            <div class="ps-key">配速</div>
                            <div class="ps-value"><span
                                class="ps-num">{{ formatSeconds(sportAbility.lactatePace.value) }}</span>/公里
                            </div>
                            <div class="xl-key">心率</div>
                            <div class="xl-value"><span class="ps-num">{{
                                    sportAbility.lactateHr.value ?
                                        sportAbility.lactateHr.value : '--'
                                }}</span>次/分
                            </div>
                        </div>
                    </van-col>
                    <van-col span="12">
                        <div class="health-item">
                            <div class="health-item-title">跑步成绩预测</div>
                            <div class="health-item-date">{{
                                    sportAbility.forecast5.date ?
                                        changeDate(sportAbility.forecast5.date) : '--'
                                }}
                            </div>
                            <div class="ps-key">半马</div>
                            <div class="ps-value"><span
                                class="ps-num">{{ formatSeconds2(sportAbility.forecastHalfMarathon.value) }}</span>
                            </div>
                            <div class="xl-key">全马</div>
                            <div class="xl-value"><span
                                class="ps-num">{{ formatSeconds2(sportAbility.forecastMarathon.value) }}</span>
                            </div>
                        </div>
                    </van-col>
                    <van-col span="12">
                        <div class="health-item">
                            <div class="health-item-title">训练状态</div>
                            <div class="health-item-date">{{
                                    sportAbility.trainingStatus.date ?
                                        changeDate(sportAbility.trainingStatus.date) : '--'
                                }}
                            </div>
                            <div class="status-box">
                                <van-row gutter="8">
                                    <van-col span="3">
                                        <div class="status-item"
                                             :class="{'status-0':sportAbility.trainingStatus.value == 0}"><img
                                            class="status-icon" v-if="sportAbility.trainingStatus.value == 0"
                                            src="@/assets/theme/light/share/14friendDesc/10arr.png"></div>
                                    </van-col>
                                    <van-col span="3">
                                        <div class="status-item"
                                             :class="{'status-1':sportAbility.trainingStatus.value == 1}"><img
                                            class="status-icon" v-if="sportAbility.trainingStatus.value == 1"
                                            src="@/assets/theme/light/share/14friendDesc/10arr.png"></div>
                                    </van-col>
                                    <van-col span="3">
                                        <div class="status-item"
                                             :class="{'status-2':sportAbility.trainingStatus.value == 2}"><img
                                            class="status-icon" v-if="sportAbility.trainingStatus.value == 2"
                                            src="@/assets/theme/light/share/14friendDesc/10arr.png"></div>
                                    </van-col>
                                    <van-col span="3">
                                        <div class="status-item"
                                             :class="{'status-3':sportAbility.trainingStatus.value == 3}"><img
                                            class="status-icon" v-if="sportAbility.trainingStatus.value == 3"
                                            src="@/assets/theme/light/share/14friendDesc/10arr.png"></div>
                                    </van-col>
                                    <van-col span="3">
                                        <div class="status-item"
                                             :class="{'status-4':sportAbility.trainingStatus.value == 4}"><img
                                            class="status-icon" v-if="sportAbility.trainingStatus.value == 4"
                                            src="@/assets/theme/light/share/14friendDesc/10arr.png"></div>
                                    </van-col>
                                    <van-col span="3">
                                        <div class="status-item"
                                             :class="{'status-5':sportAbility.trainingStatus.value == 5}"><img
                                            class="status-icon" v-if="sportAbility.trainingStatus.value == 5"
                                            src="@/assets/theme/light/share/14friendDesc/10arr.png"></div>
                                    </van-col>
                                    <van-col span="3">
                                        <div class="status-item"
                                             :class="{'status-6':sportAbility.trainingStatus.value == 6}"><img
                                            class="status-icon" v-if="sportAbility.trainingStatus.value == 6"
                                            src="@/assets/theme/light/share/14friendDesc/10arr.png"></div>
                                    </van-col>
                                    <van-col span="3">
                                        <div class="status-item"
                                             :class="{'status-7':sportAbility.trainingStatus.value == 7}"><img
                                            class="status-icon" v-if="sportAbility.trainingStatus.value == 7"
                                            src="@/assets/theme/light/share/14friendDesc/10arr.png"></div>
                                    </van-col>
                                </van-row>
                            </div>
                            <div class="xlzt-level">{{ getTrainingStatus(sportAbility.trainingStatus.value) }}</div>
                        </div>
                    </van-col>
                </van-row>
            </div>
        </div>
        <div class="health-box sport-box" v-if="sportDataStatus">
            <div class="privilege-title">运动记录</div>
            <div class="to-all" @click="toAll(0)" v-if="sportItem">
                <img class="to-all-icon"
                     src="@/assets/theme/light/desc/01prodInstructions/04to.svg">
            </div>
            <div class="d-item" v-if="sportItem">
                <div class="d-top">
                    <img class="d-avatar"
                         :src="sportItem.userAvatar ? sportItem.userAvatar : defaultImg">
                    <div class="d-info">
                        <div class="d-username">{{ user.userNameRemark ? user.userNameRemark : user.userName }}</div>
                        <div class="d-time">{{ sportItem.createTime }}</div>
                    </div>
                </div>
                <div class="d-sport" v-if="sportItem.sportId" @click="openDynamicDesc(sportItem)">
                    <div class="d-sport-type">{{ sportItem.sportType }}</div>
                    <div class="d-sport-info">{{ (sportItem.distance / 100000).toFixed(2) }}<span
                        class="d-unit">公里</span>
                        <img class="d-sport-time" src="@/assets/theme/light/share/01home/08time.png">
                        {{ formatSeconds3(sportItem.actTime) }}
                    </div>
                    <img class="d-sport-icon" :src="require(`@/assets/share/home/${sportItem.sportType}.svg`)">
                </div>
                <div class="d-bottom">
                    <van-row>
                        <van-col span="12">
                            <div class="d-b-item d-b-item-left">
                                <img v-if="sportItem.isLike" class="d-b-icon"
                                     src="@/assets/theme/light/share/01home/09liked.svg"
                                     @click="like(sportItem, 0)">
                                <img v-if="!sportItem.isLike" class="d-b-icon"
                                     src="@/assets/theme/light/share/01home/09like.svg"
                                     @click="like(sportItem, 1)">
                                <span class="like-num">{{ sportItem.likeNum == 0 ? '赞' : sportItem.likeNum }}</span>
                            </div>
                        </van-col>
                        <van-col span="12" @click="clickComment(sportItem, 0, sportItem)">
                            <div class="d-b-item">
                                <img class="d-b-icon" src="@/assets/theme/light/share/01home/10commit.svg">
                                <span
                                    class="comment-num">{{
                                        sportItem.commentList.length > 0 ? sportItem.commentList.length : '评论'
                                    }}</span>
                            </div>
                        </van-col>
                    </van-row>
                </div>
                <div class="d-comment" v-if="sportItem.commentList.length > 0">
                    <div class="d-comment-box">
                        <div class="d-comment-item"
                             @click="clickComment(sportItem, 1, c)"
                             v-for="(c, index) in sportItem.commentList">
                            <span @click="toFriendDesc(c.userId)">
                            <img class="comment-avatar" :src="c.userAvatar ? c.userAvatar : defaultImg">
                                <span
                                    class="comment-username">{{
                                        c.userNameRemark ? c.userNameRemark : c.userName
                                    }}</span></span>
                            <span v-if="c.type == 1">
                                <span>回复</span>
                                <span class="comment-username"
                                      @click="toFriendDesc(c.toUserId)">{{
                                        c.toUserNameRemark ? c.toUserNameRemark : c.toUserName
                                    }}：</span>
                            </span>
                            <span v-if="c.type == 0" class="comment-username">:</span>
                            {{ c.content }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="d-item" v-if="!sportItem">
                <div class="no-prop">
                    TA今年还没有运动记录
                </div>
            </div>
        </div>
        <div class="health-box sport-box" v-if="ecgDataStatus">
            <div class="privilege-title">心电数据</div>
            <div class="to-all" @click="toAll(1)" v-if="ecgItem">
                <img class="to-all-icon"
                     src="@/assets/theme/light/desc/01prodInstructions/04to.svg">
            </div>
            <div class="d-item" v-if="ecgItem">
                <div class="d-top">
                    <img class="d-avatar"
                         :src="ecgItem.userAvatar ? ecgItem.userAvatar : defaultImg">
                    <div class="d-info">
                        <div class="d-username">{{ user.userNameRemark ? user.userNameRemark : user.userName }}</div>
                        <div class="d-time">{{ ecgItem.createTime }}</div>
                    </div>
                </div>
                <div class="d-ecg" v-if="ecgItem.ecgId" @click="openDynamicDesc(ecgItem)">
                    <van-row>
                        <van-col span="14">
                            <div class="d-ecg-left">
                                <div class="ecg-info">
                                    <div v-if="!ecgItem.isError" class="ecg-normal"></div>
                                    <div v-if="ecgItem.isError" class="ecg-error"></div>
                                    <div class="ecg-conclusion">{{ ecgItem.conclusion }}</div>
                                </div>
                                <div class="ecg-from">由<span class="ecg-add">{{ ecgItem.deviceName }}</span>采集</div>
                            </div>
                        </van-col>
                        <div class="ecg-chart" :id="ecgItem.ecgId"></div>
                    </van-row>
                </div>
                <div class="d-bottom">
                    <van-row>
                        <van-col span="12">
                            <div class="d-b-item d-b-item-left">
                                <img v-if="ecgItem.isLike" class="d-b-icon"
                                     src="@/assets/theme/light/share/01home/09liked.svg"
                                     @click="like(ecgItem, 0)">
                                <img v-if="!ecgItem.isLike" class="d-b-icon"
                                     src="@/assets/theme/light/share/01home/09like.svg"
                                     @click="like(ecgItem, 1)">
                                <span class="like-num">{{ ecgItem.likeNum == 0 ? '赞' : ecgItem.likeNum }}</span>
                            </div>
                        </van-col>
                        <van-col span="12" @click="clickComment(ecgItem, 0, ecgItem)">
                            <div class="d-b-item">
                                <img class="d-b-icon" src="@/assets/theme/light/share/01home/10commit.svg">
                                <span
                                    class="comment-num">{{
                                        ecgItem.commentList.length > 0 ? ecgItem.commentList.length : '评论'
                                    }}</span>
                            </div>
                        </van-col>
                    </van-row>
                </div>
                <div class="d-comment" v-if="ecgItem.commentList.length > 0">
                    <div class="d-comment-box">
                        <div class="d-comment-item"
                             @click="clickComment(ecgItem, 1, c)"
                             v-for="(c, index) in ecgItem.commentList">
                            <span @click="toFriendDesc(c.userId)">
                            <img class="comment-avatar" :src="c.userAvatar ? c.userAvatar : defaultImg">
                                <span
                                    class="comment-username">{{
                                        c.userNameRemark ? c.userNameRemark : c.userName
                                    }}</span></span>
                            <span v-if="c.type == 1">
                                <span>回复</span>
                                <span class="comment-username"
                                      @click="toFriendDesc(c.toUserId)">{{
                                        c.toUserNameRemark ? c.toUserNameRemark : c.toUserName
                                    }}：</span>
                            </span>
                            <span v-if="c.type == 0" class="comment-username">:</span>
                            {{ c.content }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="d-item" v-if="!ecgItem">
                <div class="no-prop">
                    TA还没有心电数据
                </div>
            </div>
        </div>
        <div class="invite" v-show="!isFriend" @click="toConfirm">邀请TA</div>
        <van-popup v-model="showComment" position="bottom" style="background: #f3f3f3">
            <div class="apply-value">
                <van-field v-model="commentInfo.content" :placeholder="commentInfo.type == 0 ? '评论':'回复'">
                    <template #button>
                        <van-button size="mini" type="primary" @click="sendComment">发送</van-button>
                    </template>
                </van-field>
            </div>
        </van-popup>
    </div>
</template>

<script>
import {getToday, changeDate, formatSeconds} from "../../utils/dateUtils";
import {Dialog, Toast} from 'vant';
import {SwitchTime, SwitchTimeToM, formatSeconds3, formatSeconds2} from '@/utils/dateUtils';
import gpsBaidu from "../../components/gpsBaidu";
import {WebJSBridge} from "../../utils/JSBridge1";
import {getSkin} from "../../utils/comment";

export default {
    name: 'friendDescLight',
    components: {
        gpsBaidu
    },
    data() {
        return {
            theme: 'light',
            ratio: 1,
            sharerId: localStorage.getItem('sharerId'),
            user: {},
            defaultImg: require('@/assets/share/home/noImg.png'),
            isFriend: 1,
            bodyStatus: 0,
            sportDataStatus: 0,
            ecgDataStatus: 0,
            sportItem: {
                commentList: []
            },
            ecgItem: {
                commentList: []
            },
            showComment: false,
            commentInfo: {},
            sportAbility: {
                "vo2max": {
                    "date": "",
                    "value": 0
                },
                "lactatePace": {
                    "date": "",
                    "value": 0
                },
                "lactateHr": {
                    "date": "",
                    "value": 0
                },
                "forecast5": {
                    "date": "",
                    "value": 0
                },
                "forecast10": {
                    "date": "",
                    "value": 0
                },
                "forecastHalfMarathon": {
                    "date": "",
                    "value": 0
                },
                "forecastMarathon": {
                    "date": "",
                    "value": 0
                },
                "trainingLoad": {
                    "date": "",
                    "value": 0
                },
                "trainingStatus": {
                    "date": "",
                    "value": 0
                },
                "fitnessAge": {
                    "date": "",
                    "value": 0
                },
                "staminaLevel": {
                    "date": "",
                    "value": 0
                }
            }, // 运动能力
            showTargetIcon: false
        }
    },
    mounted() {
        if (this.$route.query.theme) {
            this.theme = this.$route.query.theme
        }
        this.ratio = document.body.clientWidth / 375 ? document.body.clientWidth / 375 : 1;
        this.getFriendInfo();
    },
    methods: {
        back() {
            this.$router.back();
        },
        openDynamicDesc(item) {
            WebJSBridge.call("openDynamicDesc", {
                ecgId: item.ecgId,
                sportId: item.sportId,
                sportType: item.sportType,
                userAvatar: item.userAvatar,
                startSportTime: item.createTime
            }, function (res) {
                console.log("recieve callback")
                console.log(res)
            });
        },
        toAll(tag) {
            if (this.user.userNameRemark) {
                localStorage.setItem('userNameRemark', this.user.userNameRemark);
            }
            localStorage.setItem('allTag', tag);
            localStorage.setItem('allSharerId', this.user.userId);
            this.$router.push({
                name: 'allDynamicsLight',
                query: {
                    theme: this.theme
                }
            })
        },
        toCondition() {
            this.$router.push({
                name: 'conditionLight',
                query: {
                    theme: this.theme
                }
            })
        },
        toPersonal() {
            this.$router.push({
                name: 'personalLight',
                params: {
                    isFirend: this.isFriend
                },
                query: {
                    theme: this.theme
                }
            })
        },
        toConfirm() {
            localStorage.setItem("addUser", JSON.stringify(this.user));
            this.$router.push({
                name: 'confirmLight',
                params: {
                    type: 'qr'
                },
                query: {
                    theme: this.theme
                }
            })
        },
        getFriendInfo() {
            this.$api.share.getFriendsDetail({
                date: getToday(),
                sharerId: this.sharerId
            }).then(res => {
                this.user = res.info.friendData;
                this.user.userId = this.sharerId;
                this.isFriend = res.info.status;
                this.bodyStatus = res.info.bodyStatus;
                this.sportDataStatus = res.info.sportDataStatus;
                this.ecgDataStatus = res.info.ecgDataStatus;
                this.sportItem = res.info.sportData;
                this.ecgItem = res.info.ecgData;

                if (this.ecgDataStatus && this.ecgItem && this.ecgItem.ecgId) {
                    this.$nextTick(function () {
                        this.drawEcg(this.ecgItem);
                    })
                }

                if (this.user.calorie) {
                    this.user.calorie = Math.round(this.user.calorie / 1000);
                } else {
                    this.user.calorie = 0;
                }
                if (!this.user.step) {
                    this.user.step = 0;
                }

                // 计算canvas尺寸
                let clientWidth = document.documentElement.clientWidth;
                let ratio = clientWidth / 375;
                this.showTargetIcon = true
                let stepScore = this.user.step / this.user.userTargetStep > 1 ? 1 : this.user.step / this.user.userTargetStep;
                let calorieScore = this.user.calorie / this.user.userTargetCalorie > 1 ? 1 : this.user.calorie / this.user.userTargetCalorie;
                this.toCanvasTarget("myCanvas", stepScore * 100, 100, '#00BD9B', '#E3F6ED', 40, ratio);
                this.toCanvasTarget("myCanvas2", calorieScore * 100, 100, '#FF7347', '#FFF6E8', 20, ratio);

                if (this.bodyStatus) {
                    this.sportAbility = res.info.sportAbility;
                    this.drawProgressbg();
                    let vo2Ratio = 0;
                    if (this.sportAbility.vo2max.value) {
                        if (this.sportAbility.vo2max.value < 23.9) {
                            vo2Ratio = 0
                        } else if (this.sportAbility.vo2max.value >= 56) {
                            vo2Ratio = 1
                        } else {
                            vo2Ratio = (this.sportAbility.vo2max.value - 23.9) / 32.1
                        }
                        this.drawCircle(vo2Ratio);
                    }
                    this.dealLevel(this.sportAbility.staminaLevel.value);

                    this.dealFitnessAge(this.sportAbility.fitnessAge.value);
                    this.dealTrainLoad(this.sportAbility.trainingLoad.value);
                }
            })
        },
        // 绘制半圆
        toCanvasTarget(id, progress, progress2, color, colorBg, radius, ratio) {
            //canvas进度条
            var canvas = document.getElementById(id),
                ctx = canvas.getContext("2d"),
                percent = progress,
                percent2 = progress2,
                //最终百分比
                circleX = ratio * 50, // 中心x坐标
                circleY = ratio * 50, //中心y坐标
                radius = ratio * radius, //圆环半径
                lineWidth = ratio * 10; // 圆形线条的宽度
            var devicePixelRatio = window.devicePixelRatio || 1;
            ctx.canvas.width = ratio * 100 * devicePixelRatio;
            ctx.canvas.height = ratio * 100 * devicePixelRatio;
            ctx.scale(devicePixelRatio, devicePixelRatio);

            //画圆
            function circle(cx, cy, r) {
                ctx.beginPath();
                ctx.lineWidth = lineWidth;
                ctx.strokeStyle = colorBg;
                ctx.lineCap = 'round';
                ctx.arc(cx, cy, r, Math.PI, Math.PI * 2);
                //ctx.arc(cx, cy, r, Math.PI * 2 / 3, Math.PI * 1 / 3);
                ctx.stroke();
            }

            //画弧线
            function sector(cx, cy, r, startAngle, endAngle, anti) {
                ctx.beginPath();
                ctx.lineWidth = lineWidth;

                // 渐变色 - 可自定义
                var linGrad = ctx.createLinearGradient(
                    circleX - radius - lineWidth, circleY, circleX + radius + lineWidth, circleY
                );
                linGrad.addColorStop(0.0, color);
                linGrad.addColorStop(1.0, color);
                ctx.strokeStyle = linGrad;
                //圆弧两端的样式
                ctx.lineCap = 'round';
                ctx.arc(cx, cy, r, Math.PI, Math.PI * (1 + endAngle / 100));
                ctx.stroke();
            }

            //刷新
            function loading() {
                var percent3 = progress;
                if (percent < percent2) percent = percent2;
                if (process >= percent) clearInterval(circleLoading);
                // if (process2 >= percent) clearInterval(circleLoading);
                //清除canvas内容
                ctx.clearRect(0, 0, circleX * 2, circleY * 2);

                //圆形
                circle(circleX, circleY, radius);

                //圆弧
                sector(circleX, circleY, radius, Math.PI * 2 / 3, process);

                //控制结束时动画的速度
                if (process < percent3) {
                    if (process / percent > 0.90) {
                        process += 0.30;
                    } else if (process / percent > 0.80) {
                        process += 0.55;
                    } else if (process / percent > 0.70) {
                        process += 0.75;
                    } else {
                        process += 1.0;
                    }
                }

            }

            var process = 0.0;

            var circleLoading = window.setInterval(function () {
                loading();
            }, 20);

        },
        toPrivilege() {
            localStorage.setItem("addUser", JSON.stringify(this.user));
            this.$router.push({
                name: 'remarkSetLight',
                params: {
                    type: 'update'
                },
                query: {
                    theme: this.theme
                }
            })
        },
        getPrivilege() {
            this.$api.share.selectAuthority({
                sharerId: this.user.userId
            }).then(res => {
                localStorage.setItem("statusPrivilege", res.info.statusPrivilege);
                localStorage.setItem("ecgPrivilege", res.info.ecgPrivilege);
                localStorage.setItem("sportPrivilege", res.info.sportPrivilege);
                localStorage.setItem("remark", this.user.userNameRemark);
                this.toPrivilege();
            })
        },
        toFriendDesc(userId) {
            if (userId != localStorage.getItem("userId")) {
                localStorage.setItem("sharerId", userId);
                this.$router.push({
                    name: 'friendDescLight',
                    query: {
                        theme: this.theme
                    }
                })
            }
        },
        checkPower(sportType) {
            let tag = 0;
            if (sportType == '自由训练' || sportType == '俯卧撑' || sportType == '深蹲' || sportType == '卷腹' || sportType == '平板支撑' || sportType == '椭圆机' || sportType == '划船机' || sportType == '跳绳') {
                tag = 1;
            }
            return tag;
        },
        dealTime(n) {
            return SwitchTime(n);
        },
        dealSwolf(item) {
            let is806 = 0;
            if (item.watchName) {
                if (item.watchName.indexOf("TA806") != -1) {
                    is806 = 1;
                }
            } else {
                is806 = 1;
            }
            let swolf = item.avgSwolf;
            if (is806) {
                swolf = parseInt(swolf / 10)
            }
            return swolf;
        },
        dealPach(item) {
            let is806 = 0;
            if (item.watchName) {
                if (item.watchName.indexOf("TA806") != -1) {
                    is806 = 1;
                }
            } else {
                is806 = 1;
            }
            let value = item.avgSpeed;
            if (!is806 && (item.sportType != '室内游泳')) {
                value = value == 0 ? 0 : 10000 / (value ? value : 1);
            }
            if (!is806 && (item.sportType == '室内游泳')) {
                value = value == 0 ? 0 : 1000 / (value ? value : 1);
            }
            return SwitchTimeToM(value);
        },
        clickComment(item, type, c) {
            this.currentD = item;
            this.commentInfo = {
                ecgId: item.ecgId,
                sportType: item.sportType,
                sportId: item.sportId,
                startSportTime: item.createTime,
                type: type,
                toUserId: c.userId,
                content: '',
                userId: localStorage.getItem('userId'),
                userAvatar: localStorage.getItem('userAvatar').indexOf('http') != -1 ? localStorage.getItem('userAvatar') : '',
                userName: localStorage.getItem('userName'),
                toUserName: c.userNameRemark ? c.userNameRemark : c.userName
            }
            this.showComment = true;
        },
        sendComment() {
            this.$api.share.comment(this.commentInfo).then(res => {
                if (this.commentInfo.ecgId) {
                    this.ecgItem.commentList.push(this.commentInfo);
                    this.$set(this.ecgItem, 'commentList', this.ecgItem.commentList);
                } else {
                    this.sportItem.commentList.push(this.commentInfo);
                    this.$set(this.sportItem, 'commentList', this.sportItem.commentList);
                }
                this.showComment = false;
                this.commentInfo = {}
            }).catch(e => {
                Toast('发言不符合社区规范！');
            })
        },
        drawEcg(item) {
            let a = item.ecgFragment;
            let b = a.split(',');
            let c = [];
            for (let i = 0; i < b.length; i++) {
                c.push(i);
            }
            let myChart = this.$echarts.init(document.getElementById(item.ecgId));
            myChart.setOption({
                grid: {
                    top: 0,
                    bottom: 0,
                    left: 10,
                    right: 10
                },
                xAxis: {
                    type: 'category',
                    axisLine: {
                        show: false,
                    },
                    axisLabel: {
                        show: false
                    },
                    axisTick: {
                        show: false
                    },
                    splitLine: {
                        show: false
                    },
                    data: c
                },
                yAxis: {
                    type: 'value',
                    position: 'right',
                    axisLabel: {
                        show: false
                    },
                    splitLine: {
                        show: false
                    }
                },
                series: [
                    {
                        data: b,
                        type: 'line',
                        symbol: 'none',
                        color: '#FF0101',
                        smooth: false,
                        lineStyle: {
                            width: 3
                        }
                    }
                ]
            }, true);
        },
        like(item, isLike) {
            this.$api.share.like({
                ecgId: item.ecgId,
                sportId: item.sportId,
                sportType: item.sportType,
                startSportTime: item.createTime,
                isLike,
                toUserId: item.userId
            }).then(res => {
                this.$set(item, 'isLike', isLike);
                if (isLike) {
                    this.$set(item, 'likeNum', item.likeNum + 1);
                } else {
                    this.$set(item, 'likeNum', item.likeNum - 1);
                }
            })
        },
        drawProgressbg() {
            let ctx = document.getElementById('cpbg').getContext('2d');
            let devicePixelRatio = window.devicePixelRatio || 1;
            ctx.canvas.width = this.ratio * 100 * devicePixelRatio;
            ctx.canvas.height = this.ratio * 100 * devicePixelRatio;
            ctx.scale(devicePixelRatio, devicePixelRatio);
            ctx.lineWidth = this.ratio * 9; // 设置圆环的宽度
            ctx.strokeStyle = getSkin('--bg-color-1'); // 设置圆环的颜色
            ctx.lineCap = 'butt'; // 设置圆环端点的形状
            ctx.setLineDash([2, 4]);
            ctx.beginPath(); //开始一个新的路径
            ctx.arc(this.ratio * 50, this.ratio * 50, this.ratio * 40, 0.95 * Math.PI, 2.05 * Math.PI, false);
            //设置一个原点(110,110)，半径为100的圆的路径到当前路径
            ctx.stroke(); //对当前路径进行描边
        },
        drawCircle(step) {
            let ctx = document.getElementById('cpbar').getContext('2d');
            let devicePixelRatio = window.devicePixelRatio || 1;
            ctx.canvas.width = this.ratio * 100 * devicePixelRatio;
            ctx.canvas.height = this.ratio * 100 * devicePixelRatio;
            ctx.scale(devicePixelRatio, devicePixelRatio);
            // 进度条的渐变(中心x坐标-半径-边宽，中心Y坐标，中心x坐标+半径+边宽，中心Y坐标)
            let increase = 0.05;
            let end = 0.95 * Math.PI + step * 1.1 * Math.PI; // 最后的角度
            let current = 0.95 * Math.PI; // 起始角度
            let timer = setInterval(() => {
                ctx.lineWidth = this.ratio * 9;
                ctx.strokeStyle = getSkin('--chart-color-8');
                ctx.lineCap = 'butt'; // 设置圆环端点的形状
                ctx.setLineDash([2, 4]);
                ctx.beginPath();
                // 参数step 为绘制的百分比
                if (current < end) {
                    current = current + increase;
                }
                if (current >= end) {
                    current = end;
                    clearInterval(timer);
                }
                ctx.arc(this.ratio * 50, this.ratio * 50, this.ratio * 40, 0.95 * Math.PI, current, false);
                ctx.stroke();
            }, 20);
        },
        // 处理训练负荷
        dealTrainLoad(fuheNum) {
            let fuheRatio = 0;
            if (fuheNum < 0.8) {
                fuheRatio = 1 / 5;
            } else if (fuheNum <= 1.5) {
                fuheRatio = 1 / 2;
            } else if (fuheNum <= 2) {
                fuheRatio = 4 / 5;
            } else if (fuheNum > 2) {
                fuheRatio = 1
            }

            this.toCanvas('fuhe-chart', fuheNum, 'fuhe', fuheRatio);
        },
        // 处理体能年龄
        dealFitnessAge(fAge) {
            let age = this.user.age;
            let tRatio = 0;
            if (fAge < age) {
                this.character = '<';
                tRatio = 1 / 6;
            } else if (fAge == age) {
                tRatio = 1 / 2;
                this.character = '=';
            } else if (fAge > age) {
                tRatio = 5 / 6;
                this.character = '>';
            }
            this.toCanvas('tnnl-chart', fAge, 'age', tRatio);
        },
        // 绘制半圆
        toCanvas(id, num, type, ratio) {
            //canvas进度条
            let ctx = document.getElementById(id).getContext('2d');
            let devicePixelRatio = window.devicePixelRatio || 1;
            ctx.canvas.width = this.ratio * 100 * devicePixelRatio;
            ctx.canvas.height = this.ratio * 100 * devicePixelRatio;
            ctx.scale(devicePixelRatio, devicePixelRatio);
            num = num;
            //最终百分比
            let circleX = this.ratio * 50; // 中心x坐标
            let circleY = this.ratio * 50; //中心y坐标
            let radius = this.ratio * 40; //圆环半径
            let lineWidth = this.ratio * 4; // 圆形线条的宽度

            //画圆
            function circle(cx, cy, r, sa, ea, color, lineWidth) {
                ctx.beginPath();
                ctx.lineWidth = lineWidth;
                ctx.strokeStyle = color;
                ctx.arc(cx, cy, r, sa, ea);
                //ctx.arc(cx, cy, r, Math.PI * 2 / 3, Math.PI * 1 / 3);
                ctx.stroke();
            }

            //刷新
            function loading() {
                //圆形
                let c1 = 'rgba(0,0,0,0.1)', c2 = 'rgba(0,0,0,0.1)', c3 = 'rgba(0,0,0,0.1)';
                let lw1 = lineWidth, lw2 = lineWidth, lw3 = lineWidth;
                if (type == 'fuhe') {
                    if (num > 0 && num < 0.8) {
                        c1 = '#2A6BEE';
                        lw1 = 2 * lw1;
                    } else if (num > 0 && num <= 1.5) {
                        c2 = '#00BD9B';
                        lw2 = 2 * lw2;
                    } else if (num > 0 && num > 1.5) {
                        c3 = '#7D4EFF';
                        lw3 = 2 * lw3;
                    }
                } else {
                    if (ratio == 1 / 6) {
                        c1 = '#2A6BEE';
                        lw1 = 2 * lw1;
                    } else if (ratio == 1 / 2) {
                        c2 = '#00BD9B';
                        lw2 = 2 * lw2;
                    } else if (ratio == 5 / 6) {
                        c3 = '#FF7347';
                        lw3 = 2 * lw3;
                    }
                }

                circle(circleX, circleY, radius, 0.95 * Math.PI, 1.35 * Math.PI - 0.04, c1, lw1);
                circle(circleX, circleY, radius, 1.35 * Math.PI + 0.04, 1.65 * Math.PI - 0.04, c2, lw2);
                circle(circleX, circleY, radius, 1.65 * Math.PI + 0.04, Math.PI * 2.05, c3, lw3);
                let image = new Image()
                image.src = require('@/assets/theme/light/share/14friendDesc/10arr.png')
                image.onload = () => {
                    // 平移转换，改变画笔的原点位置为画布的中心点
                    ctx.translate(50, 50);
                    // 旋转转换，改变画笔的旋转角度
                    ctx.rotate(((270 + ratio * 180) * Math.PI) / 180);
                    // 调用绘制图片的方法把图片绘制到canvas中
                    // context.drawImage(image, -image.width / 2, -image.height / 2);
                    ctx.drawImage(image, -11, -6.5 - 35, 22, 13);
                }
            }

            loading();
        },
        dealLevel(num) {
            let ratio = 0;
            if (num <= 19) {
                ratio = 0;
            } else if (num <= 29) {
                ratio = 1 / 6;
            } else if (num <= 39) {
                ratio = 2 / 6;
            } else if (num <= 49) {
                ratio = 1 / 2;
            } else if (num <= 59) {
                ratio = 1 / 2 + 1 / 6;
            } else if (num <= 69) {
                ratio = 1 / 2 + 2 / 6;
            } else {
                ratio = 1;
            }
            this.toCanvasLevel('tndj-chart', num, ratio);
        },
        toCanvasLevel(id, num, ratio) {
            //canvas进度条
            let ctx = document.getElementById(id).getContext('2d');
            let devicePixelRatio = window.devicePixelRatio || 1;
            ctx.canvas.width = this.ratio * 100 * devicePixelRatio;
            ctx.canvas.height = this.ratio * 100 * devicePixelRatio;
            ctx.scale(devicePixelRatio, devicePixelRatio);
            num = num;
            //最终百分比
            let circleX = 50; // 中心x坐标
            let circleY = 50; //中心y坐标
            let radius = 40; //圆环半径
            let lineWidth = 4; // 圆形线条的宽度
            //画圆
            function circle(cx, cy, r, sa, ea, color, lineWidth) {
                ctx.beginPath();
                ctx.lineWidth = lineWidth;
                ctx.strokeStyle = color;
                ctx.arc(cx, cy, r, sa, ea);
                //ctx.arc(cx, cy, r, Math.PI * 2 / 3, Math.PI * 1 / 3);
                ctx.stroke();
            }

            //画弧线
            function sector(cx, cy, r, startAngle, endAngle, anti) {
                ctx.beginPath();
                ctx.lineWidth = lineWidth;

                // 渐变色 - 可自定义
                var linGrad = ctx.createLinearGradient(
                    circleX - radius - lineWidth, circleY, circleX + radius + lineWidth, circleY
                );
                linGrad.addColorStop(0.0, color);
                linGrad.addColorStop(1.0, color);
                ctx.strokeStyle = linGrad;
                //圆弧两端的样式
                ctx.lineCap = 'butt';
                ctx.arc(cx, cy, r, Math.PI, Math.PI * (1 + endAngle / 100));
                ctx.stroke();
            }

            //刷新
            function loading() {
                //圆形
                let c1 = 'rgba(0,0,0,0.1)', c2 = 'rgba(0,0,0,0.1)', c3 = 'rgba(0,0,0,0.1)', c4 = 'rgba(0,0,0,0.1)',
                    c5 = 'rgba(0,0,0,0.1)', c6 = 'rgba(0,0,0,0.1)', c7 = 'rgba(0,0,0,0.1)';
                let lw1 = lineWidth, lw2 = lineWidth, lw3 = lineWidth, lw4 = lineWidth, lw5 = lineWidth,
                    lw6 = lineWidth, lw7 = lineWidth;
                if (num <= 19) {
                    c1 = '#7D4EFF';
                    lw1 = lw1 * 2;
                } else if (num <= 29) {
                    c2 = '#2D3BFF';
                    lw2 = lw2 * 2;
                } else if (num <= 39) {
                    c3 = '#30CBEB';
                    lw3 = lw3 * 2;
                } else if (num <= 49) {
                    c4 = '#00BD9B';
                    lw4 = lw4 * 2;
                } else if (num <= 59) {
                    c5 = '#F1DB1B';
                    lw5 = lw5 * 2;
                } else if (num <= 69) {
                    c6 = '#FF7347';
                    lw6 = lw6 * 2;
                } else {
                    c7 = '#FF0101';
                    lw7 = lw7 * 2;
                }

                circle(circleX, circleY, radius, 0.95 * Math.PI, 1.11 * Math.PI - 0.04, c1, lw1);
                circle(circleX, circleY, radius, 1.11 * Math.PI + 0.04, 1.27 * Math.PI - 0.04, c2, lw2);
                circle(circleX, circleY, radius, 1.27 * Math.PI + 0.04, 1.43 * Math.PI - 0.04, c3, lw3);
                circle(circleX, circleY, radius, 1.43 * Math.PI + 0.04, 1.57 * Math.PI - 0.04, c4, lw4);
                circle(circleX, circleY, radius, 1.57 * Math.PI + 0.04, 1.73 * Math.PI - 0.04, c5, lw5);
                circle(circleX, circleY, radius, 1.73 * Math.PI + 0.04, 1.89 * Math.PI - 0.04, c6, lw6);
                circle(circleX, circleY, radius, 1.89 * Math.PI + 0.04, 2.05 * Math.PI, c7, lw7);
                let image = new Image()
                image.src = require('@/assets/theme/light/share/14friendDesc/10arr.png')
                image.onload = () => {
                    // 平移转换，改变画笔的原点位置为画布的中心点
                    ctx.translate(50, 50);
                    // 旋转转换，改变画笔的旋转角度
                    ctx.rotate(((270 + ratio * 180) * Math.PI) / 180);
                    // 调用绘制图片的方法把图片绘制到canvas中
                    // context.drawImage(image, -image.width / 2, -image.height / 2);
                    ctx.drawImage(image, -11, -6.5 - 35, 22, 13);
                }
            }

            loading();
        },
        formatSeconds3(m) {
            return formatSeconds3(m)
        },
        changeDate(n) {
            return changeDate(n);
        },
        getVo2MaxLevel(n) {
            if (n <= 0) {
                return '--'
            } else if (n < 23.9) {
                return '【很差】'
            } else if (n < 30.5) {
                return '【不良】'
            } else if (n < 37.6) {
                return '【普通】'
            } else if (n < 44.7) {
                return '【良好】'
            } else if (n < 56) {
                return '【优异】'
            } else {
                return '【顶尖】'
            }
        },
        formatSeconds(n) {
            return formatSeconds(n)
        },
        getStaminaLevel(n) {
            if (n == 0) {
                return '--';
            } else if (n < 20) {
                return '【初学者】';
            } else if (n < 30) {
                return '【运动新手】';
            } else if (n < 40) {
                return '【挑战者】'
            } else if (n < 50) {
                return '【运动者】'
            } else if (n < 60) {
                return '【运动爱好者】'
            } else if (n < 70) {
                return '【运动狂热者】'
            } else if (n <= 80) {
                return '【菁英运动员】'
            } else {
                return '--'
            }
        },
        formatSeconds2(n) {
            if (n == 0) {
                return '--'
            } else {
                return formatSeconds2(n)
            }
        },
        getTrainingLoadLevel(n) {
            if (n == 0) {
                return '--';
            } else if (n < 0.8) {
                return '【低】'
            } else if (n <= 1.5) {
                return '【最佳】'
            } else if (n > 1.5) {
                return '【高】'
            }
        },
        getTrainingStatus(n) {
            if (n == 0) {
                return '【无状态期】'
            } else if (n == 1) {
                return '【过度训练期】'
            } else if (n == 2) {
                return '【停止训练期】'
            } else if (n == 3) {
                return '【退步期】'
            } else if (n == 4) {
                return '【维持期】'
            } else if (n == 5) {
                return '【恢复期】'
            } else if (n == 6) {
                return '【进步期】'
            } else if (n == 7) {
                return '【减量期】'
            }
        }
    },
}
</script>

<style scoped>
.top-box {
    width: 100%;
    height: 178px;
    position: relative;
}

.bg {
    width: 100%;
    margin-top: 88px;
}

.banner {
    position: absolute;
    width: 100%;
    top: 0;
    background: transparent;
    border: none;
}

.set-icon {
    width: 22px;
    height: 22px;
    margin: 11px 15px 11px 10px;
    float: right;
}

.user-icon {
    position: absolute;
    width: 50px;
    height: 50px;
    border: 2px solid var(--text-color-1);
    top: 94px;
    left: 36px;
    border-radius: 50%;
}

.user-name-remark {
    position: absolute;
    left: 96px;
    top: 107px;
    font-size: 19px;
    color: var(--text-color-1);
}

.user-name {
    position: absolute;
    left: 96px;
    top: 72px;
    font-size: 15px;
}

.user-info-btn {
    border: 2px solid var(--text-color-1);
    border-radius: 12px;
    position: absolute;
    right: 15px;
    top: 106px;
    color: var(--text-color-1);
    width: 80px;
    text-align: center;
}

.uuser-info-text {
    margin: 3px 4px;
    font-size: 15px;
}

.target-box {
    width: 345px;
    height: 124px;
    background: var(--bg-color-2);
    border-radius: 15px;
    margin: -12px auto 0;
    z-index: 111;
    position: relative;
}

.step-chart-box {
    width: 190px;
    height: 124px;
    position: absolute;
    left: 0;
    top: 0;
}

.step-bar {
    width: 5px;
    height: 5px;
    background: #00BD9B;
    position: absolute;
    left: 192px;
    top: 20px;
    border-radius: 50%;
}

.cal-bar {
    width: 5px;
    height: 5px;
    background: #FF7347;
    position: absolute;
    left: 192px;
    top: 69px;
    border-radius: 50%;
}

.step-title {
    font-size: 12px;
    color: var(--text-color-3);
    position: absolute;
    left: 200px;
    top: 16px;
    line-height: 12px;
}

.step-target-value {
    position: absolute;
    left: 191px;
    top: 29px;
    font-size: 22px;
}

.cal-target-value {
    position: absolute;
    left: 191px;
    top: 78px;
    font-size: 22px;
}

.cal-title {
    font-size: 12px;
    color: var(--text-color-3);
    position: absolute;
    left: 200px;
    top: 65px;
    line-height: 12px;
}

.step-current {
    color: var(--text-color-1);
    font-size: 22px;
    font-family: PP;
}

.target-num {
    color: var(--text-color-3);
    font-size: 12px;
    margin-left: 4px;
}

.unit {
    color: var(--text-color-3);
    font-size: 12px;
    margin-left: 6px;
}

.cal-current {
    color: var(--text-color-1);
    font-size: 22px;
    font-family: PP;
}

.step-pro-box {
    position: absolute;
    width: 148px;
    height: 120px;
    left: 26px;
    top: 22px;
}

.step-icon {
    position: absolute;
    width: 12px;
    left: 9px;
    top: 68px;
    z-index: 11;
}

.cal-icon {
    position: absolute;
    width: 12px;
    left: 38px;
    top: 68px;
    z-index: 11;
}

#myCanvas {
    position: absolute;
    width: 148px;
    height: 148px;
    right: 0px;
    top: 0px;
}

#myCanvas2 {
    position: absolute;
    width: 148px;
    height: 148px;
    right: 0px;
    top: 0px;
}

.health-box {
    width: 345px;
    margin: 20px auto 0;
    color: var(--text-color-1);
}

.privilege-title {
    font-size: 17px;
    position: relative;
    line-height: 26px;
    color: var(--text-color-1);
    margin-bottom: 15px;
}

.health-item {
    width: 165px;
    height: 145px;
    background: var(--bg-color-2);
    border-radius: 13px 13px 13px 13px;
    margin-bottom: 15px;
    position: relative;
    overflow: hidden;
}

.health-item-last {
    margin-bottom: 0px;
    height: 175px;
}

.health-item-title {
    font-size: 15px;
    color: var(--text-color-1);
    position: absolute;
    left: 17px;
    top: 14px;
    line-height: 15px;
}

.to-icon {
    width: 16px;
    position: absolute;
    right: 10px;
    top: 21px;
}

.invite {
    font-size: 17px;
    color: var(--text-color-1);
    line-height: 56px;
    width: 345px;
    height: 56px;
    border-radius: 13px 13px 13px 13px;
    border: 2px solid #404040;
    position: absolute;
    bottom: 20px;
    left: 15px;
    text-align: center;
}

.sport-box {
    position: relative;
}

.to-all {
    font-size: 14px;
    position: absolute;
    right: 20px;
    top: 3px;
}

.to-all-icon {
    width: 22px;
    position: absolute;
    right: -20px;
    top: 0px;
}

.dynamics {
    margin: 15px 15px;
}

.d-item {
    width: 100%;
    background: var(--bg-color-2);
    margin-bottom: 10px;
    border-radius: 6px;
    padding-bottom: 6px;
}

.d-avatar {
    border-radius: 50%;
    width: 40px;
    height: 40px;
    border: 2px solid var(--text-color-1);
    margin: 14px 10px 15px 17px;
    vertical-align: top;
}

.d-info {
    display: inline-block;
    margin-top: 14px;
}

.d-username {
    opacity: 0.9;
    font-size: 14px;
    line-height: 24px;
    color: var(--text-color-1);
}

.d-time {
    opacity: 0.4;
    font-size: 12px;
    color: var(--text-color-1);
}

.icon-box {
    width: 56px;
    height: 56px;
    border-radius: 4px;
    background: var(--text-color-1);
    border: 1px solid var(--text-color-3);
    margin: 12px 10px 10px 15px;
    display: inline-block;
    vertical-align: top;
}

.s-info {
    display: inline-block;
}

.s-num-box {
    margin-top: 3px;
}

.s-num-unit {
    opacity: 0.7;
    font-size: 11px;
}

.s-num {
    font-family: BlackItalic;
    font-size: 35px;
    opacity: 1;
    letter-spacing: 3px;
    margin-right: 2px;
}

.s-sub-icon {
    width: 11px;
    vertical-align: top;
}

.s-sub {
    opacity: 0.6;
    margin-top: 5px;
    font-size: 11px;
}

.s-type {
    float: right;
    background-size: contain;
    width: 72px;
    height: 72px;
    margin-right: 5px;
}

.s-type-text {
    text-align: center;
    opacity: 0.6;
    margin-top: 30px;
    font-size: 14px;
    font-weight: 400;
}

.d-sport {
    width: 315px;
    height: 65px;
    background: var(--bg-color-1);
    margin: 0 auto;
    border-radius: 13px 13px 13px 13px;
    position: relative;
}

.d-sport-type {
    font-size: 15px;
    color: var(--text-color-1);
    position: absolute;
    top: 10px;
    left: 16px;

}

.d-desc-item {
    text-align: center;
    margin-bottom: 16px;
}

.d-desc-center {
    /*border-left: 1px solid var(--bg-color-2);*/
    position: relative;
}

.d-desc-center:before {
    content: '';
    position: absolute;
    left: 0;
    top: 35%;
    bottom: auto;
    right: auto;
    height: 40%;
    width: 1px;
    background-color: #636363;
}

.d-desc-center:after {
    content: '';
    position: absolute;
    left: auto;
    top: 35%;
    bottom: auto;
    right: 0;
    height: 40%;
    width: 1px;
    background-color: #636363;
}

.desc-num {
    font-family: Bold;
    font-size: 24px;
}

.desc-title {
    color: #A5A5A5;
    font-size: 11px;
}

.d-bottom {
    /*border-top: 1px solid var(--text-color-1);*/
}

.d-b-item {
    text-align: center;
    font-size: 13px;
    line-height: 22px;
    margin-top: 6px;
    color: var(--text-color-1);
}

.d-b-icon {
    width: 22px;
    vertical-align: bottom;
}

.d-b-item-left {
    position: relative;
}

.ecg-info {
    position: relative;
}

.ecg-normal {
    width: 6px;
    height: 6px;
    background: #00BD9B;
    border-radius: 50%;
    opacity: 1;
    position: absolute;
    top: 50%;
    left: 15px;
}

.ecg-error {
    width: 6px;
    height: 6px;
    background: #FF0101;
    border-radius: 50%;
    opacity: 1;
    position: absolute;
    top: 50%;
    left: 15px;
}

.ecg-conclusion {
    display: inline-block;
    font-size: 15px;
    color: var(--text-color-1);
    margin-left: 25px;
    margin-top: 10px;
}

.ecg-from {
    color: #A5A5A5;
    font-size: 12px;
    margin-left: 15px;
    margin-top: 5px;
}

.ecg-add {
    font-weight: bold;
    color: var(--text-color-1) !important;
    margin: 0 2px;
}

.d-ecg-left {
    margin: 5px 0 15px 0;
}

.d-ecg {
    width: 315px;
    position: relative;
    background: var(--bg-color-1);
    border-radius: 10px 10px 10px 10px;
    margin: 0 auto;
}

.ecg-chart {
    position: absolute;
    right: 0;
    top: 0px;
    width: 150px;
    height: 73px;
}

.d-comment {
    border-radius: 10px 10px 10px 10px;
    border: 2px solid var(--text-color-1);
    margin: 6px 10px 6px 10px;
}

.d-comment-box {
    padding: 6px 12px;
}

.d-comment-item {
    color: var(--text-color-2);
    line-height: 26px;
    font-size: 14px;
}

.comment-avatar {
    width: 15px;
    height: 15px;
    border-radius: 50%;
    vertical-align: middle;
}

.comment-comment {
    color: #999999;
}

.comment-username {
    color: var(--text-color-1);
}

/deep/ input {
    background-color: var(--bg-color-1);
    color: var(--text-color-1);
    font-size: 14px;
    caret-color: #20D38F;
    padding: 7px 10px;
    height: 28px;
    border-radius: 6px;
}

/deep/ input::-webkit-input-placeholder {
    color: var(--text-color-1);
    opacity: 0.2;
}

/deep/ input::-moz-placeholder {
    color: var(--bg-color-2);
    opacity: 0.6;
}

/deep/ input:-moz-placeholder {
    color: var(--bg-color-2);
    opacity: 0.6;
}

/deep/ input::-ms-input-placeholder {
    color: var(--bg-color-2);
    opacity: 0.6;
}

/deep/ .van-cell {
    background-color: var(--bg-color-2) !important;
    border-radius: 6px;
    padding: 8px;
}

/deep/ .van-button--primary {
    background-color: #00BD9B;
    border-radius: 6px;
    font-size: 14px;
    padding: 7px;
    height: 28px;
    border-color: #00BD9B;
}

.no-prop {
    font-size: 14px;
    color: #707070;
    text-align: center;
    padding: 30px 0 25px 0;
}

.health-item-box {
    width: 343px;
    margin-top: 15px;
}

.health-item-icon {
    width: 18px;
    position: absolute;
    right: 16px;
    top: 15px;
}

.health-item-date {
    color: var(--text-color-3);
    font-size: 13px;
    font-family: PP;
    position: absolute;
    left: 117px;
    top: 13px;
}

.progress_bg {
    position: absolute;
    top: 42px;
    left: 17px;
    width: 130px;
    height: 130px;
}

.progress_bar {
    position: absolute;
    top: 42px;
    left: 17px;
    width: 130px;
    height: 130px;
}

.progress_line {
    position: absolute;
    top: 42px;
    left: 17px;
    width: 130px;
    height: 130px;
}

.vo2-value {
    font-size: 27px;
    color: var(--text-color-1);
    width: 165px;
    position: absolute;
    top: 72px;
    text-align: center;
    font-family: PP;
}

.vo2-level {
    font-size: 15px;
    color: var(--text-color-1);
    width: 165px;
    position: absolute;
    top: 116px;
    text-align: center;
    line-height: 15px;
}

.ps-key {
    width: 40px;
    height: 23px;
    background: var(--bg-color-1);
    border-radius: 20px 20px 20px 20px;
    color: var(--text-color-1);
    font-size: 13px;
    position: absolute;
    top: 55px;
    left: 13px;
    text-align: center;
    line-height: 23px;
}

.ps-value {
    font-size: 12px;
    color: var(--text-color-2);
    position: absolute;
    top: 51px;
    left: 61px;
}

.ps-num {
    color: var(--text-color-1);
    font-size: 22px;
    font-family: PP;
    margin-right: 5px;
}

.xl-key {
    width: 40px;
    height: 23px;
    background: var(--bg-color-1);
    border-radius: 20px 20px 20px 20px;
    color: var(--text-color-1);
    font-size: 13px;
    position: absolute;
    top: 98px;
    left: 13px;
    text-align: center;
    line-height: 23px;
}

.xl-value {
    font-size: 13px;
    color: var(--text-color-2);
    position: absolute;
    top: 94px;
    left: 61px;
}

.circle-box {
    width: 130px;
    height: 130px;
    position: relative;
    top: 35px;
    left: 17.5px;
}

.health-item-yc {
    position: relative;
    width: 345px;
    height: 144px;
    background: var(--bg-color-2);
    border-radius: 13px 13px 13px 13px;
    margin-bottom: 0.4rem;
    position: relative;
    overflow: hidden;
}

.bar {
    width: 4px;
    height: 11px;
    border-radius: 3px 3px 3px 3px;
    position: absolute;
}

.bar1 {
    background: #00BD9B;
    left: 18px;
    top: 76px;
}

.bar2 {
    background: #2A6BEE;
    left: 196px;
    top: 76px;
}

.bar3 {
    background: #FF7347;
    left: 18px;
    top: 111px;
}

.bar4 {
    background: #FF0101;
    left: 196px;
    top: 111px;
}

.bar-key {
    font-size: 15px;
    color: var(--text-color-2);
    position: absolute;
    line-height: 15px;
}

.bar-key1 {
    left: 27px;
    top: 74px;
}

.bar-key2 {
    left: 205px;
    top: 74px;
}

.bar-key3 {
    left: 27px;
    top: 109px;
}

.bar-key4 {
    left: 205px;
    top: 109px;
}

.bar-value {
    font-size: 19px;
    color: var(--text-color-1);
    font-family: PP;
    position: absolute;
}

.bar-value1 {
    left: 61px;
    top: 69px;
}

.bar-value2 {
    left: 239px;
    top: 69px;
}

.bar-value3 {
    left: 61px;
    top: 103px;
}

.bar-value4 {
    left: 239px;
    top: 103px;
}

.xlzt-level {
    width: 100%;
    font-size: 15px;
    color: var(--text-color-1);
    position: absolute;
    top: 116px;
    text-align: center;
}

.xlzt-desc {
    width: 109px;
    background: var(--bg-color-1);
    border-radius: 10px 10px 10px 10px;
    position: absolute;
    left: 13px;
    top: 100px;
    color: var(--text-color-2);
    font-size: 13px;
    padding: 10px 15px;
    line-height: 16px;
}

.content-body {
    color: var(--text-color-1);
}

.d-sport-info {
    font-family: PP;
    font-size: 19px;
    position: relative;
    top: 30px;
    left: 16px;
    display: flex;
    align-items: center;
}

.d-unit {
    font-size: 13px;
    color: rgba(0, 0, 0, 0.5);
    margin-left: 4px;
    vertical-align: middle;
}

.d-sport-time {
    width: 17px;
    margin-left: 12px;
    margin-right: 4px;
    vertical-align: middle;
}

.d-sport-icon {
    width: 30px;
    position: absolute;
    right: 21px;
    top: 16px;
}

.status-box {
    margin: 13px 15px;
    height: 60px;
}

.status-item {
    width: 100%;
    margin-top: 30px;
    height: 58px;
    background-color: #E8ECF2;
    position: relative;
}

.status-0 {
    background-color: #B8C3D4;
}

.status-1 {
    background-color: #2A6BEE;
}

.status-2 {
    background-color: #30CBEB;
}

.status-3 {
    background-color: #00BD9B;
}

.status-4 {
    background-color: #F1DB1B;
}

.status-5 {
    background-color: #FF7347;
}

.status-6 {
    background-color: #EB6A65;
}

.status-7 {
    background-color: #FF0101;
}

.status-icon {
    width: 20px;
    position: absolute;
    bottom: -7px;
    left: calc(50% - 10px);
}
</style>



// WEBPACK FOOTER //
// src/views/shareLight/14friendDesc.vue